import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import JobsDashboard from "../../components/JobsDashboard/JobsDashboard";
import "./JobsDashboardPage.scss";

function JobsDashboardPage() {
  const auth = useAuth();
  const navigate = useNavigate();

  const email = auth.user?.profile?.email || auth.user?.profile?.sub || "User";

  return (
    <div className="jdp-page">
      <main className="jdp-main">
        <JobsDashboard userEmail={email} onNewJob={() => navigate("/services")} />
      </main>
    </div>
  );
}

export default JobsDashboardPage;
